import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import PhoneTwoToneSvg from "@ant-design/icons-svg/es/asn/PhoneTwoTone";
import AntdIcon from "../components/AntdIcon";
var PhoneTwoTone = function PhoneTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PhoneTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  PhoneTwoTone.displayName = 'PhoneTwoTone';
}
export default /*#__PURE__*/React.forwardRef(PhoneTwoTone);